import React from "react";
import { FieldArray } from "formik";
import { Grid, Button } from "@mui/material";
import { Processor } from "../../../../../store/terminal/types";
import { AdditionalData } from "../../../../../store/processor/types";
import AdditionalDataInput from "./additionalDataInput";
import SectionWrapper from "../../../../../common/pageSections/SectionWrapper";
import { Add } from "@mui/icons-material";

interface AdditionalDataForm {
  index: number;
  processor: Processor;
  isUpdateAllowed?: boolean;
}

const AdditionalDataForm = (props: AdditionalDataForm) => {
  const { index, processor, isUpdateAllowed } = props;

  return (
    <FieldArray
      name={`attributes.Processor[${index}].AdditionalData`}
      render={(arrayHelpers): React.ReactElement => {
        return (
          <SectionWrapper isChild title="Additional Data">
            <Grid container spacing={2}>
              {processor?.AdditionalData?.map(
                (addtlData: AdditionalData, dataIndex) => {
                  return (
                    <AdditionalDataInput
                      key={dataIndex}
                      index={index}
                      dataIndex={dataIndex}
                      arrayHelpers={arrayHelpers}
                      isUpdateAllowed={isUpdateAllowed}
                    />
                  );
                }
              )}
              <Grid item xs={12}>
                <Button
                  color="primary"
                  variant="outlined"
                  size="small"
                  startIcon={<Add />}
                  onClick={() =>
                    arrayHelpers.push({
                      Tag: "",
                      Value: "",
                      Encrypted: false,
                      isNew: true,
                    })
                  }
                  disabled={!isUpdateAllowed}
                >
                  Add Additional Data
                </Button>
              </Grid>
            </Grid>
          </SectionWrapper>
        );
      }}
    />
  );
};

export default AdditionalDataForm;
